import { ref, computed, onBeforeMount } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.regexp.flags.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b096336c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "left_product_list"
};
const _hoisted_3 = {
  class: "tableContent"
};
const _hoisted_4 = {
  class: "top_header"
};
const _hoisted_5 = {
  key: 0,
  class: "bottom_body"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  style: {
    width: '52px'
  }
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "right_config_list"
};
const _hoisted_10 = {
  class: "tab_container"
};
const _hoisted_11 = {
  class: "device_container"
};
const _hoisted_12 = {
  class: "device_list"
};
const _hoisted_13 = {
  class: "device_config"
};
import { Empty } from 'ant-design-vue';
import DeviceList from './components/DeviceList.vue';
import DeviceConfig from './components/DeviceConfig.vue';
import AddDeviceId from './components/AddDeviceId.vue';
import IconCopy from '@/components/IconCopy.vue';
import { columns, FILTER_CHANNEL_LIST, resolveChannelName } from './data';
import { getTestDeviceListFetch, getTestConfigListFetch, getScenarioListFetch } from '@/api/sandbox';
import { queryAppList } from '@/api/payManage/appManage';
import { reportEvent } from '@/common';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'testConfig'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const keywords = ref('');
    const productLoading = ref(false);
    const deviceLoading = ref(false);
    const configLoading = ref(false);
    const showAddDeviceId = ref(false);
    const dbtProducts = ref([]); // 全量的产品列表
    const payChannelList = ref([]);
    const deviceList = ref([]);
    const testConfigList = ref([]);
    const scenarioList = ref([]);
    const curChoosedProduct = ref({
      dbtId: '',
      appName: ''
    }); // 当前选中的产品dbtId
    const curPayChnl = ref(''); // 当前选中的支付渠道
    const curDeviceId = ref(''); // 当前选中的设备ID
    function flattenPayChannels(flags = []) {
      var _flags$flatMap$map, _flags$flatMap;
      return (_flags$flatMap$map = flags === null || flags === void 0 || (_flags$flatMap = flags.flatMap(flag => {
        var _flag$payChnls;
        return (_flag$payChnls = flag === null || flag === void 0 ? void 0 : flag.payChnls) !== null && _flag$payChnls !== void 0 ? _flag$payChnls : [];
      })) === null || _flags$flatMap === void 0 ? void 0 : _flags$flatMap.map(channel => {
        var _channel$payChlCode, _channel$payChlName;
        const code = (_channel$payChlCode = channel === null || channel === void 0 ? void 0 : channel.payChlCode) !== null && _channel$payChlCode !== void 0 ? _channel$payChlCode : '';
        return {
          dimensionCode: code,
          dimensionName: resolveChannelName(code, (_channel$payChlName = channel === null || channel === void 0 ? void 0 : channel.payChlName) !== null && _channel$payChlName !== void 0 ? _channel$payChlName : '')
        };
      })) !== null && _flags$flatMap$map !== void 0 ? _flags$flatMap$map : [];
    }
    // 测试对象类型 1 应用 2 设备
    const testObjectType = computed(() => {
      return curDeviceId.value ? 2 : 1;
    });
    const productList = computed(() => {
      if (!keywords.value) {
        return dbtProducts.value;
      }
      const keyword = keywords.value.toLowerCase(); // 转换为小写以进行不区分大小写的比较
      const matchesKeyword = item => {
        return [item.appName, item.dbtId, item.filePath, item.appId, item.pkg].filter(item => Boolean(item)).some(field => String(field).toLowerCase().includes(keyword));
      };
      return dbtProducts.value.filter(matchesKeyword);
    });
    const changeDeviceId = item => {
      curDeviceId.value = item === curDeviceId.value ? '' : item;
      getTestConfigList();
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '测试配置',
          element_name: `切换设备ID`
        }
      });
    };
    // 查询测试配置
    const getTestConfigList = async () => {
      if (!curChoosedProduct.value.dbtId || !curPayChnl.value) return;
      try {
        configLoading.value = true;
        const params = {
          dbtId: curChoosedProduct.value.dbtId,
          payChnl: curPayChnl.value,
          testObjectType: testObjectType.value
        };
        if (curDeviceId.value) {
          params.deviceId = curDeviceId.value;
        }
        const {
          code,
          data
        } = await getTestConfigListFetch(params);
        if (code === '0000') {
          var _data$list;
          testConfigList.value = (_data$list = data === null || data === void 0 ? void 0 : data.list) !== null && _data$list !== void 0 ? _data$list : [];
        } else {
          testConfigList.value = [];
        }
      } catch (error) {
        testConfigList.value = [];
      } finally {
        configLoading.value = false;
      }
    };
    // 获取设备Id列表
    const getDeviceIdList = async () => {
      if (!curChoosedProduct.value.dbtId) return;
      try {
        deviceLoading.value = true;
        const {
          code,
          data
        } = await getTestDeviceListFetch({
          dbtId: curChoosedProduct.value.dbtId
        });
        if (code === '0000') {
          var _data$deviceList, _deviceList$value;
          deviceList.value = (_data$deviceList = data === null || data === void 0 ? void 0 : data.deviceList) !== null && _data$deviceList !== void 0 ? _data$deviceList : [];
          if ((_deviceList$value = deviceList.value) !== null && _deviceList$value !== void 0 && _deviceList$value.length) {
            var _deviceList$value2;
            curDeviceId.value = (_deviceList$value2 = deviceList.value) === null || _deviceList$value2 === void 0 ? void 0 : _deviceList$value2[0];
          } else {
            curDeviceId.value = '';
          }
        } else {
          deviceList.value = [];
          curDeviceId.value = '';
        }
        getTestConfigList();
        return 'succeed';
      } catch (error) {
        deviceList.value = [];
        curDeviceId.value = '';
        return 'failed';
      } finally {
        deviceLoading.value = false;
      }
    };
    // 获取支付渠道
    const getPayChannelList = item => {
      var _item$chnlInfo$flags, _item$chnlInfo, _payChannelList$value, _payChannelList$value2;
      if (!(item !== null && item !== void 0 && item.dbtId)) return;
      const flattenedPayChnls = flattenPayChannels((_item$chnlInfo$flags = item === null || item === void 0 || (_item$chnlInfo = item.chnlInfo) === null || _item$chnlInfo === void 0 ? void 0 : _item$chnlInfo.flags) !== null && _item$chnlInfo$flags !== void 0 ? _item$chnlInfo$flags : []);
      payChannelList.value = flattenedPayChnls.filter(channel => FILTER_CHANNEL_LIST.includes(channel.dimensionCode));
      curPayChnl.value = (_payChannelList$value = (_payChannelList$value2 = payChannelList.value) === null || _payChannelList$value2 === void 0 || (_payChannelList$value2 = _payChannelList$value2[0]) === null || _payChannelList$value2 === void 0 ? void 0 : _payChannelList$value2.dimensionCode) !== null && _payChannelList$value !== void 0 ? _payChannelList$value : '';
    };
    const addDeviceId = () => {
      showAddDeviceId.value = true;
    };
    const changeCurProduct = async item => {
      if (!item.dbtId) {
        throw new Error('选择的产品dbtId不能为空');
      }
      curChoosedProduct.value = item;
      getPayChannelList(item);
      await getDeviceIdList();
    };
    const changeCurPayChnl = () => {
      var _payChannelList$value3, _payChannelList$value4;
      getTestConfigList();
      const curPayChnlName = (_payChannelList$value3 = (_payChannelList$value4 = payChannelList.value.find(item => item.dimensionCode === curPayChnl.value)) === null || _payChannelList$value4 === void 0 ? void 0 : _payChannelList$value4.dimensionName) !== null && _payChannelList$value3 !== void 0 ? _payChannelList$value3 : '';
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '测试配置',
          element_name: `切换支付渠道-${curPayChnlName}`
        }
      });
    };
    const getDbtProducts = async () => {
      try {
        productLoading.value = true;
        const {
          code,
          data
        } = await queryAppList({
          pageNum: 1,
          pageSize: 9999999
        });
        if (code === '0') {
          var _data$list2, _dbtProducts$value;
          dbtProducts.value = (_data$list2 = data === null || data === void 0 ? void 0 : data.list) !== null && _data$list2 !== void 0 ? _data$list2 : [];
          if ((_dbtProducts$value = dbtProducts.value) !== null && _dbtProducts$value !== void 0 && _dbtProducts$value.length) {
            var _dbtProducts$value2;
            changeCurProduct((_dbtProducts$value2 = dbtProducts.value) === null || _dbtProducts$value2 === void 0 ? void 0 : _dbtProducts$value2[0]);
          }
        }
      } catch (error) {} finally {
        productLoading.value = false;
      }
    }; // 获取产品信息
    const getScenarioList = async () => {
      try {
        const {
          code,
          data
        } = await getScenarioListFetch();
        if (code === '0000') {
          var _data$list3;
          scenarioList.value = (_data$list3 = data === null || data === void 0 ? void 0 : data.list) !== null && _data$list3 !== void 0 ? _data$list3 : [];
        }
      } catch (error) {}
    }; // 获取产品信息
    onBeforeMount(() => {
      getDbtProducts();
      getScenarioList();
    });
    return (_ctx, _cache) => {
      var _payChannelList$value5;
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_alert = _resolveComponent("a-alert");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: keywords.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => keywords.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "产品查询",
        style: {
          "width": "100%"
        }
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          style: _normalizeStyle({
            width: item.width + 'px'
          })
        }, _toDisplayString(item.title), 5);
      }), 128))]), _createVNode(_component_a_spin, {
        spinning: productLoading.value
      }, {
        default: _withCtx(() => [_unref(productList).length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productList), item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.dbtId,
            class: _normalizeClass(["body_item", {
              active: curChoosedProduct.value.dbtId === item.dbtId
            }]),
            onClick: $event => changeCurProduct(item)
          }, [_createElementVNode("div", _hoisted_7, [_createVNode(IconCopy, {
            copyValue: item.dbtId,
            copyIconName: "productIDIcon",
            copyIconGreyName: "productIDGreyIcon"
          }, null, 8, ["copyValue"])]), _createElementVNode("div", {
            class: "app_name",
            title: item.appName
          }, _toDisplayString(item.appName), 9, _hoisted_8)], 10, _hoisted_6);
        }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
          key: 1,
          image: _unref(simpleImage)
        }, null, 8, ["image"]))]),
        _: 1
      }, 8, ["spinning"])])]), _createElementVNode("div", _hoisted_9, [(_payChannelList$value5 = payChannelList.value) !== null && _payChannelList$value5 !== void 0 && _payChannelList$value5.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_a_tabs, {
        activeKey: curPayChnl.value,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = $event => curPayChnl.value = $event),
        onChange: changeCurPayChnl
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payChannelList.value, item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.dimensionCode,
            tab: item.dimensionName
          }, null, 8, ["tab"]);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"])]), _createElementVNode("div", null, [_createVNode(_component_a_alert, {
        class: "tips_type",
        message: "测试设备添加后，该设备所有支付请求将转发至沙盒服务，如果需要测试生产环境，请移除后再进行测试。",
        banner: ""
      })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(DeviceList, {
        dbtId: curChoosedProduct.value.dbtId,
        deviceList: deviceList.value,
        loading: deviceLoading.value,
        curDeviceId: curDeviceId.value,
        onAdd: addDeviceId,
        onUpdateList: getDeviceIdList,
        onChange: changeDeviceId
      }, null, 8, ["dbtId", "deviceList", "loading", "curDeviceId"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_spin, {
        spinning: configLoading.value
      }, {
        default: _withCtx(() => [_createVNode(DeviceConfig, {
          productLoading: productLoading.value,
          dbtId: curChoosedProduct.value.dbtId,
          payChnl: curPayChnl.value,
          deviceId: curDeviceId.value,
          testObjectType: _unref(testObjectType),
          scenarioList: scenarioList.value,
          configList: testConfigList.value
        }, null, 8, ["productLoading", "dbtId", "payChnl", "deviceId", "testObjectType", "scenarioList", "configList"])]),
        _: 1
      }, 8, ["spinning"])])])], 64)) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        class: "empty_channel",
        image: _unref(simpleImage),
        description: "该产品无有效测试渠道，请配置测试渠道"
      }, null, 8, ["image"]))]), _createVNode(AddDeviceId, {
        "modal-visible": showAddDeviceId.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => showAddDeviceId.value = $event),
        dbtId: curChoosedProduct.value.dbtId,
        onUpdateList: getDeviceIdList
      }, null, 8, ["modal-visible", "dbtId"])]);
    };
  }
});